import React, { useState } from 'react';
import { 
    Box, 
    Text,
    AccordionPanel,
    AccordionItem,  
    AccordionButton,
    AccordionIcon,
    Spacer
} from '@chakra-ui/react';
import { Parser } from "html-to-react";

const DetailsContent = ({
        name, 
        text, 
        blockId,
        color
    }: 
    {
        name: string, 
        text: any,
        blockId: number,
        color: string
    }) => {

    const htmlParser = new (Parser as any)();
    
    return(
        <AccordionItem 
            id={`detail_${blockId}`} 
            border='none'
        >
            <AccordionButton 
                p='30px 20px' 
                bg={blockId % 2 == 0 ? 'gray.200' : ''}
            >
                <Text>
                    {name}
                </Text>
                <Spacer/>
                <AccordionIcon color={color}/>
            </AccordionButton>
            <AccordionPanel p='20px'>
                {htmlParser.parse(text)}               
            </AccordionPanel>
        </AccordionItem>
    )
}

export default DetailsContent;